import React from 'react'
import LayeredMedia from './LayeredMedia'

const ModelLayeredMedia = ({selectedModelList}:any) => {
  return (
    <LayeredMedia selectedModelList={selectedModelList}/>
  )
}

export default ModelLayeredMedia